export enum PrePrecatorioRejectionTypeEnum{
    COMMERCIAL_REASONS = "COMMERCIAL_REASONS"
}

export const PrePrecatorioRejectionTypeCategoryLabel = new Map<PrePrecatorioRejectionTypeEnum, string>([
    [PrePrecatorioRejectionTypeEnum.COMMERCIAL_REASONS, "Motivos Comerciais"],
  ]);


// WEBPACK FOOTER //
// ./src/services/Enum/PrePrecatorioRejectionTypeEnum.ts